module.exports = __webpack_public_path__ + "static/media/pending.1854c27a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pending.svg
// module id = 946
// module chunks = 0